import axios from "axios";
import NProgress from "nprogress";
import router from "@/router/index.js";
import vue from "vue";
import store from "@/store";
import { Message, MessageBox, Loading } from "element-ui";
// import {Base64} from 'js-base64';
import { message } from "@/utils/resetMessage";
import { refreshToken } from "@/request/api";
let baseURL = process.env.VUE_APP_BASE_URL;

const instance2 = axios.create({
  baseURL,
  timeout: 50000,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
});

// 请求拦截
instance2.interceptors.request.use(
  (config) => {
    NProgress.start(); // 进度条效果开始
    // 判断是否需要全局全局加载动画
    if (config.loading !== false) {
      // 请求显示loading 效果
      startLoadingAddCount();
    }
    let token = sessionStorage.getItem("token");
    if (token) {
      // 设置请求头
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (err) => {
    // isCloseLoading()
    return Promise.reject(err);
  }
);

// 响应拦截
instance2.interceptors.response.use(
  (res) => {
    NProgress.done(); // 进度条效果结束
    if (typeof loading !== "undefined") {
      endLoadingSubCount();
    }
    if (
      (res.data.repCode != undefined && res.data.repCode == "0000") ||
      res.data.code == 200
    ) {
      // console.log(res.data);

      endLoadingSubCount();
      return res.data;
    } else {
      if (res.data.code === 401) {
        // console.log(res);
        // refresh();
        // token刷新
        message({
          message: res.data.repMsg || res.data.msg,
          type: "error",
          duration: 5 * 1000,
        });
      } else {
        // return res.data
        /*Message({
                message: res.data.msg,
                type: 'error',
                duration: 5 * 1000
            })*/
        // let userType = sessionStorage.getItem("userType");
        // if (userType == "sysUser") {
        //   router.replace("/login");
        // }
        // if (userType == "user") {
        //   router.replace("/user/login");
        // }
        // store.commit("updataUserMenu", []);
        // sessionStorage.clear();
        // localStorage.clear();
        if (res.data.code == -40001) {
          message({
            message: '许可证文件不存在',
            type: "error",
            duration: 5 * 1000,
          });
          sessionStorage.setItem('dialogShow', true)
        } else if (res.data.code == -40002) {
          message({
            message: '许可证不合法',
            type: "error",
            duration: 5 * 1000,
          });
          sessionStorage.setItem('dialogShow', true)
        } else if (res.data.code == -40003) {
          message({
            message: '许可证已过期',
            type: "error",
            duration: 5 * 1000,
          });
          sessionStorage.setItem('dialogShow', true)
        } else if (res.data.code == -40004) {
          message({
            message: '可注册用户数已满',
            type: "error",
            duration: 5 * 1000,
          });
          sessionStorage.setItem('dialogShow', true)
        } else if (res.data.code == -40005) {
          message({
            message: '用户在线数已满',
            type: "error",
            duration: 5 * 1000,
          });
          sessionStorage.setItem('dialogShow', true)
        } else {
          message({
            message: res.data.repMsg || res.data.msg,
            type: "error",
            duration: 5 * 1000,
          });
        }

        return res.data;
      }

      let userType = sessionStorage.getItem("userType");
      if (userType == "sysUser") {
        router.replace("/login");
      }
      if (userType == "user" || userType == "userLogin") {
        router.replace("/user/login");
      }
      sessionStorage.clear();
      store.commit("updataUserMenu", []);
      localStorage.clear();
    }
  },
  (err) => {
    message({
      message: err.msg,
      type: "error",
      duration: 5 * 1000,
    });

    return Promise.reject(err);
  }
);

let loading;

// 开始加载动画
function startLoading() {
  const options = {
    spinner: "el-icon-loading",
    text: "加载中...",
    lock: true,
    background: "rgba(0, 0, 0, 0.3)",
    // fullscreen:false
  };
  loading = Loading.service(options);
}

async function refresh() {
  refreshToken({
    access_token: sessionStorage.getItem("refresh_token"),
  }).then((res) => {
    console.log(res);
    if (res.data.code === 401) {
      message({
        message: res.data.repMsg || res.data.msg,
        type: "error",
        duration: 5 * 1000,
      });
      router.replace("/login");
      sessionStorage.clear();
      localStorage.clear();
    } else if (res.data.code == 200) {
    }
  });
}

// 结束加载动画
function endLoading() {
  loading.close();
}

// 定义一个变量，有请求变量加一，收到响应变量减一
let loadingCount = 0;

/**
 * 调用一次startLoadingAddCount() 方法 开启Loading 并 loadingCount + 1
 * 调用一次endLoadingSubCount() 方法 loadingCount - 1 直到为0 关闭loading
 */
function startLoadingAddCount() {
  if (loadingCount === 0) {
    startLoading();
  }
  loadingCount++;
}

function endLoadingSubCount() {
  loadingCount--;
  if (loadingCount === 0) {
    endLoading();
  }
}

export default instance2;
